export const initialFilters = {
    filters: {},
    gridState: {
        rowGroupColumns: [],
        pivotColumns: [],
        filterModel: {},
        sortModel: [],
        columnVisibility: {}
    }
};
